// extracted by mini-css-extract-plugin
export default {"option":"ZBQEP","choice":"_1TrDQ","imgContainer":"_3kOSd","placeholder":"_2C9fQ","placeHolderShimmer":"_3E1Tc","img":"Xunvm","link":"_35wXj"};